import { render, staticRenderFns } from "./ClosedCharacterCard.vue?vue&type=template&id=797fb9b6&"
import script from "./ClosedCharacterCard.vue?vue&type=script&lang=js&"
export * from "./ClosedCharacterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports